import { WithBusyIndicator, withBusyIndicator } from "@components/busyIndicator/withBusyIndicator";
import BindingContext from "@odata/BindingContext";
import { WithOData, withOData } from "@odata/withOData";
import TerminateEmploymentFormView from "@pages/payroll/employment/TerminateEmploymentFormView";
import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";

import { AppContext } from "../../../contexts/appContext/AppContext.types";
import { FormStorage } from "../../../views/formView/FormStorage";
import PlugAndPlayForm from "../../../views/formView/PlugAndPlayForm";
import { getDefinition } from "./TerminateEmployment.def";

interface IProps extends WithBusyIndicator, WithOData, WithTranslation {
    onConfirm: () => void;
    onCancel: () => void;
    bindingContext: BindingContext;
}

interface IState {
    storage?: FormStorage;
}

class TerminateEmploymentDialog extends React.Component<IProps, IState> {
    static contextType = AppContext;

    render() {
        const { onCancel, onConfirm } = this.props;

        return (
            <PlugAndPlayForm
                getDef={getDefinition}
                t={this.props.t}
                bindingContext={this.props.bindingContext}
                formView={TerminateEmploymentFormView}
                formViewProps={{
                    dialogProps: {
                        width: "550px",
                        title: this.props.t("Employment:TerminateEmploymentDialog.Title"),
                    },
                    formProps: {
                        renderScrollbar: false,
                    },
                    onAfterConfirm: onConfirm,
                    onCancel: onCancel,
                    onClose: onCancel
                }}
            />
        );
    }
}

export default withTranslation(["Employment", "Common"])(withBusyIndicator()(withOData(TerminateEmploymentDialog)));